export interface TReferralApointment {
  id?: string;
  patient: string;
  referral_paid_proposal: string;
  datetime: Date;
  notes: string | null;
}

export enum TReferralAppointmentActions {
  DONE = "done",
  REJECT = "reject",
}
